/**
 * API Configuration
 * Centralized API base URL configuration
 * 
 * Default: https://mootcourt.n2nai.io/backend-api
 * Override: Set VITE_API_BASE_URL in .env file
 */

// API Base URL - ecourt-api (API server)
// Ensure HTTPS to avoid mixed-content errors
let apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://mootcourt.n2nai.io/backend-api'

// Remove trailing slash to avoid double slashes
apiBaseUrl = apiBaseUrl.endsWith('/') ? apiBaseUrl.slice(0, -1) : apiBaseUrl

// Force HTTPS if page is loaded via HTTPS
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && apiBaseUrl.startsWith('http://')) {
  apiBaseUrl = apiBaseUrl.replace('http://', 'https://')
  console.warn('⚠️ API URL was http://, forced to https:// to avoid mixed-content error')
}

export const API_BASE_URL = apiBaseUrl

// Log for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('🌐 API Base URL:', API_BASE_URL)
}
